import * as React from "react";
import {FunctionComponent, useEffect, useState} from "react";
import {AppBar, Button, useTheme} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import {useAppSelector} from "../../../../Config/Hooks";
import InsertChartIcon from '@mui/icons-material/InsertChart';
import {Period, PeriodSelector} from "@atiautomacao/ati-ui-library";
import {Link} from "react-router-dom";
import {
    isDashboardOverviewLayoutPage,
    isDashboardOverviewSynopticPage, isDashboardPowerPlantLayoutPage, isDashboardPowerPlantPage,
    isDashboardPowerPlantSkidLayoutPage, isDashboardPowerPlantSKidPage, SystemRoutes
} from "../../../../Utils/RouteUtils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartBar} from "@fortawesome/free-solid-svg-icons";
import {hasPermission} from "../../../../Shared/Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../../Config/Constants";


interface Props {
    onPeriod?: any,
    onClick?: any
    disableButton?: boolean
}

const periodInterval = {
    week: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 6},
    month: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 30},
    year: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 11},
    general: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 6}
}

const getLayoutUrl = (): string => {
    if(isDashboardPowerPlantSKidPage()) {
        return SystemRoutes.DASHBOARD_POWER_PLANT_SKID_LAYOUT
    }else if(isDashboardPowerPlantPage()){
        return SystemRoutes.DASHBOARD_POWER_PLANT_LAYOUT;
    }
    return SystemRoutes.DASHBOARD_OVERVIEW_LAYOUT;
}




export const HeaderMenu: FunctionComponent<Props> = ({ onClick, onPeriod, disableButton = false}: Props) => {
    const theme = useTheme();
    const account = useAppSelector(state => state.authentication.account);
    const isAuthenticated = useAppSelector((state: any) => state.authentication.isAuthenticated);
    const openMainMenu = useAppSelector((state: any) => state.layout.openMainMenu);
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const contentPagePaddingTop = useAppSelector((state: any) => state.layout.contentPagePaddingTop);
    const style = {
        linkItem: {
            marginLeft: 5,
            marginRight: 5,
            color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#fff',
            fontWeight: "500"
        },
        selectedLinkItem: {
            textDecoration: 'none',
        }
    }

    const isAuthorizedToSynoptic = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_SYNOPTIC
    ]);

    const isAuthorizedToPsPlant = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_POWER_STATION , AUTHORITIES.VIEW_DASHBOARD_POWER_STATION_PLANT_LAYOUT
    ]);
    const isAuthorizedToSkidPlant = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_DASHBOARD, AUTHORITIES.VIEW_DASHBOARD_SKID, AUTHORITIES.VIEW_DASHBOARD_SKID_PLANT_LAYOUT
    ]);

    const initialPeriod: Period = {
        groupBy: "week",
        fromDateTime: new Date(),
        toDateTime: new Date()
    };

    const [period, setPeriod] = useState<Period>(initialPeriod);

    const insertChart = () => {
        onClick()
    }

    const setMediumStyle = () => {
        if(!isAuthenticated){
            return 'initial'
        }
        if(openSubMenu){
            if(openMainMenu){
                return `${400}px`
            }
            return `${80}px`
        }
        if(openMainMenu){
            return `${80}px`
        }
        return `${0}`
    }

    useEffect(() => {
        if (onPeriod) {
            onPeriod(period);
        }
    }, [period, onPeriod]);

    const isSmallScreen = window.innerWidth <= 400;
    const isMedianScreen = window.innerWidth <= 495;

    if (isAuthenticated ) return (
        <AppBar style={{paddingTop: isSmallScreen ? 96 : isMedianScreen ? 84 : contentPagePaddingTop}}>
            <Toolbar
                sx={{
                    display: 'flex', // Define flexbox layout
                    justifyContent: 'flex-end', // Alinha tudo à direita
                    marginLeft: {xs: "initial", md: setMediumStyle()},
                    backgroundColor: theme.palette.background.default
                }}
            >
                <>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <PeriodSelector
                            styleProps={{base: {display: "flex", flexDirection: "row", alignItems: "center"}}}
                            mode="hybrid"
                            hideDatetime={false}
                            hideGroup={false}
                            inputFormat={period.groupBy === "day" ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
                            periodInterval={periodInterval}
                            period={period}
                            onChange={setPeriod}
                            groupByOptions={["day", "week", "month", "year", "general"]}
                        />
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            size={"small"}
                            color={"primary"}
                            endIcon={<InsertChartIcon />}
                            onClick={insertChart}
                            sx={{ marginLeft: 2, textTransform: 'capitalize', height: '27px' }} // Espaçamento entre os dois componentes
                        >
                            Gráficos
                        </Button>
                    </div>
                </>
            </Toolbar>
        </AppBar>
    );

    return null;
}